import React from 'react';
import { useSelector } from 'react-redux';
import { formatAmountMagnitude } from 'services/constants';

export default function RecommendationSection({
  getValueByKey,
  getSectionTitle,
  isBlackBookUrl = false,
  renderMarkdown = () => {},
}) {
  const { fundData, displayUserConfig } = useSelector(
    ({ fundData }) => fundData
  );

  const sectionsConfig =
    displayUserConfig?.data?.ic_report_ui_config?.sections || [];

  const icRecommendationSection =
    displayUserConfig?.data?.ic_report_ui_config?.sections?.find(
      (sec) => sec.key === 'recommendation'
    );

  const allClientKeys =
    displayUserConfig?.data?.client_ui_config?.sections
      ?.flatMap((section) => section.values || [])
      ?.map((item) => item.key) || [];

  const subHeaderKeys =
    icRecommendationSection?.sub_header_values?.map((item) => item.key) || [];

  const filteredFields =
    icRecommendationSection?.values?.filter(
      (field) =>
        allClientKeys.includes(field.key) && !subHeaderKeys.includes(field.key)
    ) || [];

  const sectionTitle = icRecommendationSection?.title || 'Recommendation';
  const assetClass = getValueByKey('asset_class') || '';
  const subAssetClass = getValueByKey('sub_asset_class') || '';
  const netReturnsMoic = renderMarkdown(
    getValueByKey('expected_net_returns_in_moic') || ''
  );

  const getSubSectionTitle = (config, key) => {
    return (
      config
        ?.flatMap((sec) => [
          ...(sec.values || []),
          ...(sec.sub_header_values || []),
        ])
        .find((item) => item.key === key)?.title || ''
    );
  };

  return (
    <>
      <div className="fund-wrap-web m-2 mt-3 p-3">
        <p className="web-header">{sectionTitle}</p>
      </div>

      {/* Subheaders Section */}
      <div className="web-content-header">
        {[
          {
            key: 'asset_class',
            condition: assetClass,
            render: () => (
              <p
                className={isBlackBookUrl ? 'web-content' : 'web-content-mini'}
                dangerouslySetInnerHTML={{
                  __html: `${assetClass}${
                    subAssetClass &&
                    subHeaderKeys.includes('sub_asset_class') &&
                    allClientKeys.includes('sub_asset_class')
                      ? ' / ' + subAssetClass
                      : ''
                  }`,
                }}
              />
            ),
          },
          {
            key: 'expected_net_returns_in_percent',
            condition: netReturnsMoic,
            render: () => (
              <p className="web-content">
                {getSubSectionTitle(
                  sectionsConfig,
                  'expected_net_returns_in_percent'
                )}
                : {netReturnsMoic}
                {getValueByKey('expected_net_returns_in_percent') && (
                  <>
                    {' / '}
                    {renderMarkdown(
                      getValueByKey('expected_net_returns_in_percent')
                    )}
                  </>
                )}
              </p>
            ),
          },
          {
            key: 'fund_relative_risk',
            condition: true,
            render: () => (
              <p className="web-content">
                {getSubSectionTitle(sectionsConfig, 'fund_relative_risk')}:{' '}
                {fundData?.fund_relative_risk || 'High / Average / Low'}
              </p>
            ),
          },
        ]
          .filter(
            ({ key, condition }) =>
              subHeaderKeys.includes(key) &&
              allClientKeys.includes(key) &&
              condition
          )
          .map(({ key, render }) => (
            <React.Fragment key={key}>{render()}</React.Fragment>
          ))}
      </div>

      <div className="fund-wrap-content m-2 mt-2 p-3">
        <div className="d-flex justify-content-between align-items-center">
          <div className="recomandation-content">
            {filteredFields?.map(({ key, title }) => {
              const value = getValueByKey(key) || fundData?.[key];
              // if (!value) return null;

              if (key === 'recommendation_amount') {
                return (
                  <div key={key} style={{ marginBottom: '20px' }}>
                    <p className="web-typography-recommendation">{title}:</p>
                    <p className="web-span-recommendation">
                      {value && (
                        <>
                          Commit {formatAmountMagnitude({ value: value })} to{' '}
                          {fundData.fund_name}
                        </>
                      )}
                    </p>
                    {fundData?.recommendation_summary && (
                      <p className="web-span-recommendation">
                        {fundData.recommendation_summary}
                      </p>
                    )}
                  </div>
                );
              }

              return (
                <div key={key} style={{ marginBottom: '20px' }}>
                  <p className="web-typography-recommendation">{title}:</p>
                  <p className="web-span-recommendation">
                    {renderMarkdown(value)}
                  </p>
                </div>
              );
            })}
          </div>

          <p style={{}}></p>
        </div>
      </div>
    </>
  );
}
